// extracted by mini-css-extract-plugin
export default {"ecom-header":"i2t_8M","ecomHeader":"i2t_8M"};